import request from './request';

/**
 * @description 设备信息配置
 */
export function getInfoApi(data) {
  return request.post('approve/apply/form/99999', data);
}